function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import clsx from 'clsx';
import { serializeStyles } from '@emotion/serialize';
import { insertStyles, getRegisteredStyles } from '@emotion/utils';
import { useGuaranteedMemo } from './utils/use-guaranteed-memo/use-guaranteed-memo.js';
import { useEmotionCache } from './use-emotion-cache.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var refPropertyName = "ref";
function getRef(args) {
    var ref;
    if (args.length !== 1) {
        return {
            args: args,
            ref: ref
        };
    }
    var _args = _sliced_to_array(args, 1), arg = _args[0];
    if (!_instanceof(arg, Object)) {
        return {
            args: args,
            ref: ref
        };
    }
    if (!(refPropertyName in arg)) {
        return {
            args: args,
            ref: ref
        };
    }
    ref = arg[refPropertyName];
    var argCopy = __spreadValues({}, arg);
    delete argCopy[refPropertyName];
    return {
        args: [
            argCopy
        ],
        ref: ref
    };
}
var cssFactory = function() {
    var merge = function merge(registered, css, className) {
        var registeredStyles = [];
        var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
        if (registeredStyles.length < 2) {
            return className;
        }
        return rawClassName + css(registeredStyles);
    };
    var _cssFactory = function _cssFactory(params) {
        var cache = params.cache;
        var css = function() {
            for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++){
                styles[_key] = arguments[_key];
            }
            var _getRef = getRef(styles), ref = _getRef.ref, args = _getRef.args;
            var serialized = serializeStyles(args, cache.registered);
            insertStyles(cache, serialized, false);
            return "".concat(cache.key, "-").concat(serialized.name).concat(ref === void 0 ? "" : " ".concat(ref));
        };
        var cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return merge(cache.registered, css, clsx(args));
        };
        return {
            css: css,
            cx: cx
        };
    };
    return {
        cssFactory: _cssFactory
    };
}().cssFactory;
function useCss() {
    var cache = useEmotionCache();
    return useGuaranteedMemo(function() {
        return cssFactory({
            cache: cache
        });
    }, [
        cache
    ]);
}
export { cssFactory, useCss }; //# sourceMappingURL=use-css.js.map
